import type { CSSProperties, ReactNode } from 'react';
import Eyebrow from './Eyebrow';

interface StatProps {
  label: ReactNode;
  value: ReactNode;
  sub?: ReactNode;
  /** Value font size in px. 22 (default) or 36 (large headline). */
  size?: 'stat' | 'large';
  valueColor?: string;
  className?: string;
  style?: CSSProperties;
}

/**
 * Phase 25 — eyebrow-label / value / optional sub-note triplet.
 *
 * The shape used by every headline card: small caption, large tabular
 * number, optional 11px ink-3 sub-note underneath. Two sizes — 22px (default
 * stat) and 36px (large headline TCO delta).
 */
export default function Stat({
  label,
  value,
  sub,
  size = 'stat',
  valueColor,
  className,
  style,
}: StatProps) {
  const fontSize = size === 'large' ? 36 : 22;
  return (
    <div className={className} style={style}>
      <Eyebrow>{label}</Eyebrow>
      <div
        className="tco-num"
        style={{
          fontSize,
          fontWeight: 600,
          marginTop: 4,
          color: valueColor ?? 'var(--tco-ink)',
          letterSpacing: size === 'large' ? '-0.015em' : '-0.005em',
          lineHeight: 1.1,
        }}
      >
        {value}
      </div>
      {sub && (
        <div
          style={{
            fontSize: 11,
            color: 'var(--tco-ink-3)',
            marginTop: 4,
            lineHeight: 1.45,
          }}
        >
          {sub}
        </div>
      )}
    </div>
  );
}
